import React from 'react'
import { T } from '@transifex/react'

import { pathJoin } from 'src/reducers/routing/utils'

import { createCollectionCalendarDetailViewRoutesMap } from './id'

export const createCollectionCalendarRoutesMap = (prefix: string) => ({
  ':id': (id = ':id') =>
    pathJoin(prefix)(id).chainMapAuto(
      createCollectionCalendarDetailViewRoutesMap,
      {
        title: <T _str="Collection Calendar Details" />,
        breadCrumbTitle: <T _str="Collection Calendar Details" />,
      }
    ),
  create: pathJoin(prefix)('create').chainMapAuto((prefix2) => ({
    configuration: pathJoin(prefix2)('configuration').chainWithTitle({
      title: <T _str="Create Collection Calendar" />,
      breadCrumbTitle: <T _str="Create" />,
    }),
  })),
})
